import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';

import { DialogService } from 'src/app/shared/services/dialog.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-delete-button',
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.scss'],
})
export class DeleteButtonComponent implements OnDestroy {
  private subs = new SubSink();
  @Output() delete = new EventEmitter();

  constructor(private dialogService: DialogService) {}

  remove() {
    this.subs.sink = this.dialogService
      .open({
        type: 'CONFIRM',
        title: 'DIALOG.TITLE.REMOVE',
        content: 'DIALOG.MSG.REMOVE',
      })
      .subscribe((result) => {
        if (result) this.delete.emit();
      });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
